import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'sb-insert-promo-code-block',
  templateUrl: './insert-promo-code-block.component.html',
  styleUrls: ['./insert-promo-code-block.component.scss']
})
export class InsertPromoCodeBlockComponent implements OnInit {

  @Input() shouldShowBlock = true;
  @Input() hasCode: boolean;
  @Input() promoType: string;
  @Input() promoSubtype: string;
  @Input() code: string;
  @Output() modalOpen: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit() {
  }

  openModal() {
    if (!this.hasCode) {
      this.modalOpen.emit();
    }
  }

}
